// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"0ee12224","283":"8e193076","321":"4b923ba5","453":"c4c50070","865":"0b9b4953"}[chunkId] + ".chunk.js";
};